<script>
import InputStep from '@/components/molecules/input/InputStep'
import cartItem from '@/modules/mixins/cartItem'
import debounce from 'lodash.debounce'
import { mapGetters } from 'vuex'

export default {
    name: 'CartItem',
    components: { InputStep },
    mixins: [cartItem],
    props: {
        value: {
            type: Object,
            default: () => {},
        },
        locale: null,
        currency: null,
        readonly: Boolean,
        inactive: Object,
    },
    computed: {
        ...mapGetters(['smDevice']),
        debounce() {
            return debounce(this.setQuantity, 300)
        },
        minQuantity() {
            return this.value.minimum_quantity > 0 ? this.value.minimum_quantity - 1 : 0
        },
    },
    methods: {
        setQuantity(quantity) {
            this.$emit('input', { ...this.value, ...{ quantity: quantity } })
        },
    },
}
</script>

<template lang="pug">
.cart-item.py-5.py-lg-3(v-if="value.meal" :class="{'align-items-center bg-white px-5': smDevice}")
    .d-flex.gap-4.w-100.align-items-center.justify-content-between
        div
            h3.d-flex.mb-0(:inner-html.prop="value.name")
                icon.ml-auto.text-danger(v-if="inactive" icon="fa-solid fa-exclamation-triangle")
            .d-flex.flex-wrap
                template(v-for="(optionGroup, optionGroupIndex) in sortedOptions")
                    .d-inline-flex.justify-content-start.align-items-center(
                        v-for="(option, optionIndex) in optionGroup"
                        :class="{'line-1': smDevice}"
                        :key="`orderExtra-${optionGroupIndex}-${optionIndex}`")
                        template(v-if="option.quantity > 1")
                            span.font-size-sm(:class="{'line-1': smDevice}")
                                | {{option.quantity}}
                            icon.ml-1.mr-2.font-size-micro(icon="fa-solid fa-xmark" size="sm" )
                        span.font-size-sm.text-73(
                            :inner-html.prop="`${option.name}${optionIndex + 1 < optionGroup.length || optionGroupIndex + 1 < sortedOptions.length ? '&nbsp;•&nbsp;': ''}`" 
                            :class="{'line-1': smDevice}")
            .d-flex.gap-2.h3.my-0.mt-lg-2.font-weight-normal.line-1(:class="originalPrice !== price ? 'text-primary' : 'text-73'")
                | {{ price | toCurrency(locale, currency) }}
                s.line-1.text-73(v-if="originalPrice !== price && currency") {{originalPrice | toCurrency(locale, currency)}}
    
        .d-flex
            input-step.mb-0(
                :disabled="!!inactive" 
                :value="value.quantity" 
                :readonly="readonly" 
                :min="minQuantity" 
                @input="debounce" 
                removable)       

    .mt-2.d-flex.align-items-center(v-if="inactive")
        button.btn.btn-secondary.btn-icon.btn-xs.btn-round(@click="setQuantity(0)")
            icon(icon="fa-solid fa-trash")
        .body-sm-xs.pl-4.text-danger {{inactive.message}}
</template>
